<template>
  <div class="block">
    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../RcvCatalog.js";

export default {
  props: {
    userData: Object
  },
  data:() => ({
    Catalog: Catalog
  })
}
</script>